import { useErrorLog } from "../../../hooks/useErrorLogs"
import { formatISODate } from "../../../utils/datetime"
import Loader from "../../../components/Loader"
import Modal from "../../../components/Modal"
import { memo } from "react"
import ReactJson from "react-json-view"

const ErrorRelatedReportsModal = memo(
  ({ isOpen, onClose, messageId, bodyPart, viewType, messageType }) => {
    const { data, isLoading } = useErrorLog(messageId, bodyPart, viewType)

    return (
      <Modal className="max-w-[70%] h-[70vh] overflow-y-hidden" isOpen={isOpen}>
        <div className="p-2">
          {isLoading ? (
            <div className="flex justify-center gap-3 items-center py-2">
              <Loader />
              Loading...
            </div>
          ) : data ? (
            <div className="grid grid-cols-1 gap-3">
              <div className="flex justify-between">
                <div className="flex gap-10">
                  <p>
                    <strong>Accession No: </strong> {data?.log?.accessionNo}
                  </p>
                  <p>
                    <strong>Message Id: </strong> {data?.log?.messageId}
                  </p>
                  <p>
                    <strong>Log Type: </strong> {messageType}
                  </p>
                  <p>
                    <strong>Created At: </strong>{" "}
                    {formatISODate(data?.log?.createdAt)}
                  </p>
                </div>
                <button
                  className="text-gray-600 hover:text-gray-900 text-3xl ml-auto"
                  onClick={onClose}
                >
                  ×
                </button>
              </div>
              <div className="h-[58vh] overflow-y-auto">
                <div>
                  <h2 className="text-xl font-bold mb-1">
                    Extracted Report Text
                  </h2>
                  <p className="text-gray-900">
                    {data?.log?.ExtractedReportText ?? "N/A"}
                  </p>
                </div>
                <div>
                  <h2 className="text-xl font-bold mb-1">AI Prompt</h2>
                  <pre className="text-gray-900 h-[35vh] whitespace-pre-wrap break-words overflow-y-auto bg-gray-100 p-4 rounded-lg">
                    {data?.log?.AIPrompt || "N/A"}
                  </pre>
                </div>
                <div>
                  <h2 className="text-xl font-bold mb-1">AI Response</h2>
                  <p className="text-gray-900 whitespace-pre-wrap break-words">
                    {data?.log?.AIResponse ? (
                      <div className="rounded-md bg-gray-100 p-4">
                        <ReactJson
                          displayDataTypes={false}
                          displayObjectSize={false}
                          enableClipboard={false}
                          name={null}
                          src={JSON.parse(data?.log?.AIResponse)}
                        />
                      </div>
                    ) : (
                      "N/A"
                    )}
                  </p>
                </div>
                <div className="mt-2">
                  <h2 className="text-xl font-bold">Error Description</h2>
                  <p className="text-gray-900">
                    {data?.log?.errorDesc || "N/A"}
                  </p>
                </div>
              </div>
            </div>
          ) : (
            <div className="flex flex-col">
              <div className="flex justify-between">
                <div />
                <button
                  className="text-gray-600 hover:text-gray-900 text-3xl ml-auto"
                  onClick={onClose}
                >
                  ×
                </button>
              </div>
              <h2 className="text-xl font-bold mb-1 text-center">
                No log found
              </h2>
            </div>
          )}
        </div>
      </Modal>
    )
  }
)

ErrorRelatedReportsModal.displayName = "ErrorRelatedReportsModal"

export default ErrorRelatedReportsModal
